<template>
  <div class="d-bar"></div>
  <div class="wizard-container d-flex flex-row">
    <div
      class="
        d-flex
        sidebar
        col-lg-5
        align-items-center
        justify-content-center
        flex-column
        h-100
      "
    >
      <Transition name="slide" mode="out-in">
        <div
          v-if="currentStep == 1"
          class="
            d-flex
            justify-content-center
            align-items-center
            flex-column
            wrapper
          "
        >
          <small class="w-50 text-muted m-2">
            Hier können Sie im ersten Schritt ihr GT aussuchen, mit der
            jeweiligen Tastenkonfiguration
          </small>
          <div class="d-flex">
            <img
              src="../../../public/images/gt/GT2.png"
              alt=""
              width="80"
              class="me-2"
              @click="showGTs('gt2')"
            />
            <img
              src="../../../public/images/gt/GT6.png"
              alt=""
              width="80"
              class="me-2"
              @click="showGTs('gt6')"
            />
            <img
              src="../../../public/images/gt/GT8.png"
              alt=""
              width="80"
              class="me-2"
              @click="showGTs('gt8')"
            />
            <img
              src="../../../public/images/gt/GT10D.png"
              alt=""
              width="80"
              class="me-2"
              @click="showGTs('gt10d')"
            />
            <img
              src="../../../public/images/gt/GT12.png"
              alt=""
              width="80"
              class="me-2"
              @click="showGTs('gt12')"
            />
            <img
              src="../../../public/images/gt/MT4.png"
              alt=""
              width="80"
              class="me-2"
              @click="showGTs('mt4')"
            />
            <img
              src="../../../public/images/gt/GT6L.png"
              alt=""
              width="80"
              class="me-2"
              @click="selectGT('gt2')"
            />
          </div>
          <div
            class="d-flex flex-row flex-wrap mt-3"
            v-if="currentlyActiveGtGrp.length > 0"
          >
            <div
              class="col-3"
              v-for="(inlay, index) in selectedGroup()"
              :key="index"
              @click="selectGT(index)"
            >
              {{ inlay.name }}
            </div>
          </div>
        </div>
      </Transition>
      <Transition name="slide" mode="out-in">
        <div
          v-if="currentStep == 2"
          class="
            d-flex
            justify-content-center
            align-items-center
            flex-column
            wrapper
          "
        >
          <h3>Hintergrund</h3>
          <small class="w-50 text-muted m-2">
            Hier können Sie eine Hintergrundfarbe für das Inlay aussuchen. Wenn
            Sie zufrieden sind, klicken Sie bitte auf "Weiter"
          </small>
          <div class="flex-row m-2">
            <button
              class="btn bg-dark text-white me-2"
              @click="changeBackground('black')"
            >
              schwarz
            </button>
            <button
              class="btn btn-light me-2"
              @click="changeBackground('white')"
            >
              weiß
            </button>
            <button
              class="btn btn-secondary"
              @click="changeBackground('lightgray')"
            >
              grau
            </button>
          </div>
        </div>
      </Transition>
      <Transition name="slide" mode="out-in">
        <div
          v-if="currentStep == 3"
          class="
            d-flex
            justify-content-center
            align-items-center
            flex-column
            wrapper
          "
        >
          <h3>Tasten</h3>
          <small class="w-75 text-muted m-2">
            Hier können Sie eine Hintergrundfarbe die Buttons aussuchen, ein
            Icon hinzufügen oder den Text bearbeiten. <br />Wenn Sie zufrieden
            sind, klicken Sie bitte auf "Weiter".
          </small>
          <div class="d-flex flex-row w-100">
            <div class="col-6">
              <h4>Beschriftung</h4>
              <div class="form-check w-25 m-auto">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id=""
                  @input="disableText()"
                />
                <label class="form-check-label text-muted" for="">
                  Kein Text
                </label>
              </div>
              <div class="form-check w-25 m-auto">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id=""
                  @input="toggleBarg()"
                />
                <label class="form-check-label text-muted" for="">
                  Bargraph
                </label>
              </div>
            </div>
            <div class="col-6">
              <h4>Tastenfarbe</h4>
              <div class="flex-row">
                <button
                  class="btn bg-dark text-white me-2"
                  @click="changeButtonBackground('black', index)"
                >
                  schwarz
                </button>
                <button
                  class="btn btn-light me-2"
                  @click="changeButtonBackground('white', index)"
                >
                  weiß
                </button>
                <button
                  class="btn btn-secondary"
                  @click="changeButtonBackground('lightgray', index)"
                >
                  grau
                </button>
              </div>
            </div>
          </div>
          <div class="d-flex flex-row flex-wrap w-100 mt-4">
            <div
              class="col-6"
              v-for="(button, index) in currentInlay.inlay.btns"
              :key="index"
            >
              <input
                type="text"
                class="form-control w-50 m-auto"
                name=""
                id=""
                aria-describedby="helpId"
                :placeholder="'Text für Taste ' + (index + 1)"
                :disabled="disabled"
                @input="updateText(index, $event)"
              />

              <img
                :src="imgURL('light/Licht_11.svg')"
                class="p-1"
                alt=""
                height="50"
                width="50"
                style="cursor: pointer"
                @click="updateBtnImg('light/Licht_11.svg', index)"
              />
              <!-- kind of hacky -->
              <inline-svg
                style="display: none"
                id="light/Licht_11.svg"
                :src="imgURL('light/Licht_11.svg')"
                height="50px"
                width="50px"
              ></inline-svg>
            </div>
          </div>
        </div>
      </Transition>
      <!-- <Transition name="slide" mode="out-in">
        <div v-if="currentStep == 4">
          <h4>Anmerkungen</h4>
          <div class="mb-3">
            <label for="" class="form-label"
              >Hier können Sie Anmerkungen eingeben. Besondere Wünsche bedürfen
              der Absprache mit uns.</label
            >
            <textarea class="form-control" name="" id="" rows="3"></textarea>
            <br />
            Wenn Sie mit ihrem Inlay zufrieden sind, drücken Sie auf
            fertigstellen und dann haben Sie die Option ein neues Inlay zu
            kreiren oder die fertigen Inlays an uns zu senden.
          </div>
        </div>
      </Transition> -->
      <div
        class="d-flex flex-row m-2 justify-content-between"
        style="position: absolute; bottom: 3%; left: 2%; width: 36%"
      >
        <button
          class="btn btn-primary p-2"
          @click="switchStepBack"
          v-if="currentStep > 1"
        >
          Zurück
        </button>
        <button
          class="btn btn-primary p-2 ms-auto"
          @click="cancelEdit"
          v-if="currentInlay.inlay && currentStep > 1"
        >
          Abbrechen
        </button>
        <button
          class="btn btn-primary p-2 ms-auto"
          @click="switchStepForward"
          v-if="currentInlay.inlay && currentStep < 3"
        >
          Weiter
        </button>
        <button
          class="btn btn-primary p-2 ms-auto"
          @click="addtoproject"
          v-if="currentInlay.inlay && currentStep == 3"
        >
          Fertigstellen
        </button>
      </div>
    </div>
    <div class="col-7">
      <div
        class="gt-container d-flex align-items-center justify-content-center"
      >
        <WizardGt></WizardGt>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed, ref } from "vue";
import { useStore } from "vuex";
import image64 from "@/modules/image64";
import InlineSvg from "vue-inline-svg";
import WizardGt from "./WizardGT.vue";
import { useRouter } from "vue-router";

export default {
  components: { InlineSvg, WizardGt },
  setup() {
    const router = useRouter();
    const store = useStore();
    const parsedInlays = computed(() => store.getters.parsedInlays);
    const currentProject = computed(() => store.getters.currentProject);
    const currentlyActiveGtGrp = ref("");
    const currentlyActiveGT = reactive({});
    const currentInlay = computed(() => store.getters.currentInlay);
    const inlayBtns = computed(() => store.getters.currentInlayBtns);
    const currentStep = ref(1);
    const disabled = ref(false);
    function showGTs(group) {
      currentlyActiveGtGrp.value = group;
    }
    function selectedGroup() {
      if (currentlyActiveGtGrp.value == "gt2") {
        return [
          parsedInlays.value["gt2"][0],
          parsedInlays.value["gt2"][1],
          parsedInlays.value["gt2t"][0],
        ];
      }
      if (
        currentlyActiveGtGrp.value !== "gt8" &&
        currentlyActiveGtGrp.value !== "mt4"
      ) {
        return parsedInlays.value[currentlyActiveGtGrp.value].filter((gt) =>
          gt.name.includes("2013")
        );
      }

      return parsedInlays.value[currentlyActiveGtGrp.value];
    }

    function selectGT(gt) {
      //TODO: if gtgrp gt2 and index == 2
      currentlyActiveGT.value =
        parsedInlays.value[currentlyActiveGtGrp.value][gt];
      store.commit("setCurrentInlayIndex", currentProject.value.length);
      store.dispatch("setCurrentInlay", currentlyActiveGT.value);
      // store.dispatch("addInlayToProject", currentlyActiveGT.value);
      disabled.value = false;
      currentlyActiveGT.value = currentInlay.value;
      console.log(currentInlay.value);
    }
    function changeBackground(color) {
      store.dispatch("switchInlayBackground", color);
      for (let i = 0; i < inlayBtns.value.length; i++) {
        if (color == "black" || color == "white") {
          changeContentColor(color, i);
        }
      }
    }
    function updateText(index, event) {
      inlayBtns.value[index].content.content = event.target.value;
    }
    function changeButtonBackground(color, index) {
      for (let i = 0; i < inlayBtns.value.length; i++) {
        inlayBtns.value[i].style["background-color"] = color;

        if (color == "black" || color == "white") {
          changeContentColor(color, i);
        }
      }
    }
    function changeContentColor(color, index) {
      if (color == "black") {
        inlayBtns.value[index].content.style.color = "white";
        inlayBtns.value[index].style.image.filter =
          "invert(100%) sepia(100%) saturate(0%) hue-rotate(314deg) brightness(109%) contrast(101%)";
      }
      if (color == "white") {
        inlayBtns.value[index].content.style.color = "black";
        inlayBtns.value[index].style.image.filter =
          " invert(0%) sepia(0%) saturate(0%) hue-rotate(307deg) brightness(97%) contrast(103%)";
      }
    }
    function switchStepBack() {
      currentStep.value--;
    }
    function switchStepForward() {
      currentStep.value++;
    }

    function disableText() {
      for (let button in inlayBtns.value) {
        inlayBtns.value[button].content.content = "";
      }
      disabled.value = !disabled.value;
    }
    function imgURL(img) {
      return process.env.BASE_URL + "images/icons/" + img;
    }
    function updateBtnImg(img, index) {
      let size = "50%";
      if (inlayBtns.value[index].content.content == "") size = "90%";
      if (img.length > 0) {
        image64(
          document.getElementById(img),
          (base64Img) => {
            inlayBtns.value[index].style.image["background-image"] =
              "url('" + base64Img + "')";
            inlayBtns.value[index].style.image["background-size"] =
              size + ", cover";
            inlayBtns.value[index].style.image["background-position"] =
              "center center";
          },
          "image/svg+xml"
        );
      }
    }
    function addtoproject() {
      store.dispatch("addInlayToProject", currentInlay.value);
      // console.log(currentInlay.value);
      // store.dispatch("setCurrentInlay", {});
      currentlyActiveGT.value = {};
      router.push("/wizard/absenden");
    }
    function cancelEdit() {
      currentProject.value.length > 0
        ? router.push("/wizard/absenden")
        : (currentStep.value = 1);
    }

    return {
      parsedInlays,
      selectGT,
      currentlyActiveGtGrp,
      currentInlay,
      changeBackground,
      updateText,
      changeButtonBackground,
      currentStep,
      imgURL,
      updateBtnImg,
      switchStepBack,
      switchStepForward,
      disabled,
      disableText,
      showGTs,
      selectedGroup,
      addtoproject,
      currentlyActiveGT,
      cancelEdit,
    };
  },
};
</script>

<style lang="scss" scoped>
.wizard-container {
  width: 100%;
  height: calc(100dvh - 80px);
  background: white;
  overflow: hidden;
}
.selection {
}
.sidebar {
  border-right: 1px solid lightgray;
}
.inlay-button {
  border: 1px solid lightgray;
  position: absolute;
}
.inlay-button p {
  margin-bottom: 1px;
}
.gt {
  position: relative;
}
.gt-container {
  position: relative;
  margin: auto;
  height: 100%;
  width: 100%;
  z-index: 30000;
}
.gt-btn-img {
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
}
.inlay {
  position: absolute;
  // border: 1px solid lightgray;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}

.slide-enter-to {
  position: absolute;
  left: 0;
}

.slide-enter-from {
  position: absolute;
  left: -100%;
  opacity: 0;
}

.slide-leave-to {
  position: absolute;
  right: -50%;
  opacity: 0;
}

.slide-leave-from {
  position: absolute;
  left: 0;
}
// .slide-enter-active {
//   transition: all 0.3s ease;
// }

// .slide-leave-active {
//   transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
// }

// .slide-enter-from,
// .slide-leave-to {
//   transform: translateX(20px);
//   opacity: 0;
// }
.button-content {
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  display: grid;
  justify-content: center;
  align-items: end;
}
.gt-top,
.gt-bottom {
  position: absolute;
  left: 0;
  z-index: 10;
  background-color: #fff;
}
.gt-top {
  top: 0;
  border-top: 1px solid lightgray;
}
.gt-bottom {
  bottom: 0;
  border-bottom: 1px solid lightgray;
  border-left: 1px solid lightgray;
}
.gt-right,
.gt-left {
  position: absolute;
  z-index: 10;
  background-color: #fff;
  border-top: 1px solid lightgray;
}
.gt-right {
  right: 0;
  border-right: 1px solid lightgray;
}
.gt-left {
  left: 0;
  border-left: 1px solid lightgray;
}
</style>
